export default __webpack_public_path__ + "static/media/aqi_band_4.15e94e00.svg";